// Centralized static dropdown options for the AdviseMe page
export const exerciseTimeOptions = [
  '15 Minutes',
  '30 Minutes',
  '45 Minutes',
  '60 Minutes',
  '90 Minutes',
  '90+ Minutes',
];

export const daysOptions = [
  'All Days',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

export const timelineOptions = [
  '01','02','03','04','05','06','07','08','09','10','11','12'
];

export const durationTypeOptions = ['Week','Month'];

export default {
  exerciseTimeOptions,
  daysOptions,
  timelineOptions,
  durationTypeOptions,
};
